<template>
  <div class="page">
    <div class="logo">
      <img src="/img/logo2.png" />
      <div class="logo_child"></div>
      <span style="color: white">安全快捷找兼职</span>
    </div>
    <div class="logindia">
      <img src="/img/qrcode.png" class="img1" />
      <div class="logindia_child">微信或小程序扫码登录</div>

      <div class="tab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="密码登录" name="first">
            <div class="tab_child">
              <input type="text" placeholder="请输入手机号" v-model="mobile" class="tab_child_c" />
              <div class="tab_child_a"></div>
              <input type="password" placeholder="请输入密码" v-model="password" class="tab_child_b" />
            </div>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="second">
            <div class="tab_child">
              <input type="text" placeholder="请输入手机号" v-model="mobile" class="tab_child_c" />
              <div style="height: 30px"></div>
              <input type="text" placeholder="请输入验证码" v-model="code" class="tab_child_b" />
              <span @click="getVerificationcode" class="codestya" v-if="codeShow" style="cursor: pointer;">获取验证码</span>
              <span v-if="!codeShow" class="codestyb">{{ count }}秒后重试</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="bottom_box">
        <div style="display: flex; align-items: center">
          <img class="imgfail" src="/img/fail.png" v-show="flag" />
          <span class="bottom_box_a" v-show="flag">您输入的手机号/密码有误请重新输入</span>
        </div>
        <div class="bottom_box_b" v-show="name == 'first'" style="cursor: pointer;">忘记密码?</div>
      </div>
      <div class="footer">
        <button @click="login">登录</button>
        <div class="footer_child">
          登录即同意
          <span style="color: #4c71db">《兼职呗用户协议》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mobileLoginApi, mobilesms, userlist } from "@/api/login/login";
export default {
  data () {
    return {
      codeShow: true, //获取验证码倒计时
      timer: null, //定时器
      count: "", //倒计时数字
      activeName: "second",
      name: "",
      mobile: "",
      flag: false,
      code: "",
      password: "",
    };
  },
  created () { },
  mounted () { },
  methods: {
    login () {
      if (this.activeName === 'second') {
        this.getcode();
      } else {
        this.passwordLogin();
      }
    },
    passwordLogin () {
      if (this.mobile == "") {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
        return;
      }
      if (this.password == "") {
        this.$message({
          type: "warning",
          message: "密码不能为空",
        });
        return;
      }
      const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (!reg.test(this.mobile)) {
        this.$message({
          type: "warning",
          message: "手机号格式错误",
        });
        return;
      }
      let data = {
        mobile: this.mobile,
        user_type: 1,
        password: this.password,
      };
      var that = this;
      mobileLoginApi(data).then((res) => {
        if (res.code == 200) {
          that.$store.dispatch("Login", res.data);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("user_name", res.data.mobile);
          localStorage.setItem("user_type", res.data.user_type);
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("avatar", res.data.user_avatar);
          this.$router.push({ path: "/" });
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      }).catch(() => {
        this.$message({
          type: "error",
          message: "登录失败，请检查网络或稍后再试",
        });
      });
    },
    getVerificationcode () {
      this.getsms();
    },
    handleClick (tab, event) {
      this.name = tab.name;
      this.flag = false;
      // 切换tab时清空对应字段
      if (tab.name === 'first') {
        this.code = "";
      }
    },
    getsms () {
      if (this.mobile == "") {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
        return;
      }
      const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (reg.test(this.mobile)) {
        let data = {
          mobile: this.mobile,
        };
        mobilesms(data).then((res) => {
          if (res.code == 200) {
            this.flag = false;
            this.$message({
              message: res.msg,
              type: "success",
            });
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.flag = true;
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "手机号格式错误",
        });
      }
    },
    getcode () {
      if (this.mobile == "") {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
        return;
      }
      if (this.code == "") {
        this.$message({
          type: "warning",
          message: "验证码不能为空",
        });
        return;
      }
      const reg = /^[0-9]{5}$/;
      if (reg.test(this.code) == false) {
        this.$message({
          type: "warning",
          message: "验证码为五位数数字",
        });
        return;
      }
      let data = {
        mobile: this.mobile,
        user_type: 1,
        mobile_code: this.code,
      };
      var that=this;
      mobileLoginApi(data).then((res) => {
        if (res.code == 200) {
          that.$store.dispatch("Login", res.data);
          
         // localStorage.setItem("userInfo", res.data);
          localStorage.setItem("userInfo",JSON.stringify(res.data));
        //userInfo = JSON.parse(localStorage.getItem('userInfo'));

          localStorage.setItem("user_name", res.data.mobile);
          localStorage.setItem("user_type", res.data.user_type);
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("avatar", res.data.user_avatar);

          this.$router.push({ path: "/" });
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      }).catch(() => {
        this.$message({
          type: "error",
          message: "登录失败，请检查网络或稍后再试",
        });
      });
    },
  },
  components: {},
};
</script>

<style lang='scss' scoped>
.page {
  width: 100vw;
  height: 100vh;
  background-color: #4c71db;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo {
    width: 400px;
    height: 3rem;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    img {
      width: 70px;
    }

    .logo_child {
      height: 25px;
      width: 1px;
      margin-left: 5px;
      margin-right: 5px;
      background-color: white;
    }
  }

  .logindia {
    .footer {
      .footer_child {
        padding-top: 5px;
      }
      width: 300px;
      margin: auto;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      button {
        width: 100%;
        height: 30px;
        border: none;
        outline: none;
        border-radius: 8px;
        background-color: #e5e5e5;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover{
          background: #4C71DB;
          color: #ffffff;
        }
      }
    }
    .imgfail {
      width: 15px;
      margin: 0 5px;
    }
    .bottom_box {
      .bottom_box_a {
        color: red;
        font-size: 12px;
      }
      .bottom_box_b {
        color: #4c71db;
        font-size: 12px;
      }
      width: 300px;
      display: flex;
      justify-content: space-between;
      margin: auto;
      margin-top: 15px;
      margin-bottom: 30px;
    }
    .tab {
      margin-top: 80px;
      display: flex;
      justify-content: space-around;
      .tab_child {
        width: 300px;
        .tab_child_a {
          height: 30px;
        }
        .codestya {
          color: #4c71db;
          position: absolute;
          right: 0;
          top: 76px;
          font-size: 12px;
        }
        .codestyb {
          color: #4c71db;
          position: absolute;
          right: 0;
          top: 76px;
          font-size: 12px;
        }
        .tab_child_b {
          border: none;
          outline: none;
          width: 300px;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 5px;
        }
        .tab_child_c {
          border: none;
          outline: none;
          width: 300px;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 5px;
          margin-top: 20px;
        }
      }
    }
    .logindia_child {
      text-align: center;
      line-height: 35px;
      position: absolute;
      top: 24px;
      right: 76px;
      height: 35px;
      width: 250px;
      font-size: 12px;
      background: url("/img/dialoing.png");
      background-size: 100% 100%;
    }
    .img1 {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 1px;
      right: 1px;
    }
    position: relative;
    width: 400px;
    height: 429px;
    background-color: white;
    border-radius: 8px;
  }
}
</style>
